import clsx from 'clsx'
import type {UILayout} from 'swayok-react-mdb-ui-kit/types/Common'
import {useUiLayoutStore} from '../../../../../stores'
import {FirstAdBonusPromoCard} from '../../../../layout/promo_cards/FirstAdBonusPromoCard'
import {GetAdvancePromoCard} from '../../../../layout/promo_cards/GetAdvancePromoCard'
import {PromoteYourAdsPromoCard} from '../../../../layout/promo_cards/PromoteYourAdsPromoCard'
import type {AdsListGridColumnsConfig} from '../../AdsModuleTypes'

interface AdsGridPromoBannersProps {
    listUid: string
    gridColumns: AdsListGridColumnsConfig
    sideMenuVisibleFromBsBreakpoint?: UILayout['bootstrapSize']
}

// Промо-баннеры для сетки объявлений.
export function AdsGridPromoBanners(props: AdsGridPromoBannersProps) {
    const {
        listUid,
        sideMenuVisibleFromBsBreakpoint = 'xl',
    } = props

    const bootstrapSize = useUiLayoutStore(
        state => state.bootstrapSize
    )

    const utmSource = listUid + '_items_grid'

    // Боковая панель видна только на экранах начиная с sideMenuVisibleFromBsBreakpoint.
    // В боковой панели показываются баннеры FirstAdBonusPromoCard и PromoteYourAdsPromoCard.
    // В этом случае нужно показать только баннер GetAdvancePromoCard на 3-й строке сетки.
    return (
        <>
            <GetAdvancePromoCard
                className={clsx(
                    'inside-items-list d-none',
                    'd-' + sideMenuVisibleFromBsBreakpoint + '-flex'
                )}
                utmSource={utmSource}
                {...getGridOrderAndColSpan(bootstrapSize, 3, props.gridColumns)}
            />
            <FirstAdBonusPromoCard
                className={clsx(
                    'inside-items-list',
                    'd-' + sideMenuVisibleFromBsBreakpoint + '-none'
                )}
                utmSource={utmSource}
                {...getGridOrderAndColSpan(bootstrapSize, 3, props.gridColumns)}
            />
            <PromoteYourAdsPromoCard
                className={clsx(
                    'inside-items-list',
                    'd-' + sideMenuVisibleFromBsBreakpoint + '-none'
                )}
                utmSource={utmSource}
                {...getGridOrderAndColSpan(bootstrapSize, 6, props.gridColumns)}
            />
            <GetAdvancePromoCard
                className={clsx(
                    'inside-items-list',
                    'd-' + sideMenuVisibleFromBsBreakpoint + '-none'
                )}
                utmSource={utmSource}
                {...getGridOrderAndColSpan(bootstrapSize, 9, props.gridColumns)}
            />
        </>
    )
}

// Получить порядок элемента в сетке для промо-баннера.
function getGridOrderAndColSpan(
    bsScreenSize: UILayout['bootstrapSize'],
    row: number,
    gridColumns: AdsListGridColumnsConfig
): {
    gridOrder: number
    colSpan: number
} {
    // Порядок (order) объявления в сетке указывается с шагом 10,
    // поэтому нужно найти order последнего элемента в строке row и добавить к нему 1,
    // чтобы вставить баннер в начало следующей строки.
    // Кол-во объявлений в строке передается в gridColumns[bsScreenSize].
    return {
        gridOrder: (gridColumns[bsScreenSize] * row * 10) + 1,
        colSpan: gridColumns[bsScreenSize],
    }
}
